import React from 'react';
import { ColumnsType } from 'antd/es/table';
import DetalleMetrica from './DetalleMetrica';

const DetalleDesdeDesmote: React.FC = () => {
  const columns: ColumnsType<any> = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'Nro. Orden', dataIndex: 'nro_orden', key: 'nro_orden', width: 120, align: 'right' as const },
    { title: 'Fecha Orden', dataIndex: 'fecha_orden', key: 'fecha_orden', width: 120 },
    { title: 'Nro. Fardo', dataIndex: 'nro_fardo', key: 'nro_fardo', width: 120, align: 'right' as const },
    { title: 'Nro. Lote', dataIndex: 'nro_lote', key: 'nro_lote', width: 120, align: 'right' as const },
    { title: 'Cliente', dataIndex: 'cliente', key: 'cliente', width: 200 },
  ];

  const fetchData = async (idEmpresa: number, idProducto: number, token: string): Promise<any[]> => {
    const url = `${process.env.REACT_APP_ESTADISTICAS_URL}/detalle/desde-desmote/${idEmpresa}/${idProducto}/`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error(`Error al cargar datos: ${response.status}`);
    return await response.json();
  };

  return (
    <DetalleMetrica
      titulo="Detalle de Desde Desmote"
      descripcion="Fardos producidos en desmote propio (servicio)"
      fetchData={fetchData}
      columns={columns}
      nombreArchivo="desde_desmote"
    />
  );
};

export default DetalleDesdeDesmote;

